export * from './rating.component';
export * from './rating.module';
